import { FC } from "react";
import { Tooltip } from "@mui/material";
import { LiveUsageResourceGridCreateTaskAction } from "@/components/pages/live-usage-mgmt/components/resources-area/toolbar/actions/task-create/LiveUsageResourceGridCreateTaskAction";

interface LiveUsageResourceGridCreateTaskRowActionProps {
  resourceHasTask?: boolean;
  onClose?(): void;
  masterGridId: string;
}

export const LiveUsageResourceGridCreateTaskRowAction: FC<
  LiveUsageResourceGridCreateTaskRowActionProps
> = ({ masterGridId, resourceHasTask, onClose }) => {
  return (
    <Tooltip
      arrow
      placement="top"
      title={resourceHasTask ? "This resource already has a task created." : ""}
    >
      <span>
        <LiveUsageResourceGridCreateTaskAction
          inRowAction
          onClose={onClose}
          masterGridId={masterGridId}
          disabled={resourceHasTask}
        />
      </span>
    </Tooltip>
  );
};
